module.exports = __webpack_public_path__ + "media/react/pages/add_ons/assets/mba_admissions/headshot_veronica-b04234668b7a76af49a0f058ade21f5d.png";